import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { IncomingOutgoingAmlContent, TransactionTypeEnum } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetTransactionAmlQuery } from '../store/services/customers';

const ProblemOutgoingTransactionAmlContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const {
    outgoing: { aml },
  } = useAppSelector((state) => state.customersProblemTransactions);

  const [getOutgoingAml, { isLoading }] = useLazyGetTransactionAmlQuery();

  const getOutgoingAmlAction = useCallback(() => {
    getOutgoingAml(transactionId as string);
  }, [transactionId]);

  useEffect(() => {
    if (!aml && transactionId) {
      getOutgoingAmlAction();
    }
  }, [getOutgoingAmlAction, aml, transactionId]);

  return (
    <IncomingOutgoingAmlContent
      isLoading={isLoading}
      aml={aml}
      transactionType={TransactionTypeEnum.OUTGOING}
    />
  );
};

export default ProblemOutgoingTransactionAmlContentHOC;
